import { render, staticRenderFns } from "./CallsControl.vue?vue&type=template&id=5fe73afe&"
import script from "./CallsControl.vue?vue&type=script&lang=js&"
export * from "./CallsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports